<template>
  <div>
    <PageTitle title="Transform">
      <template #actions>
        <Button @click="hideSource = !hideSource">
          {{ hideSource ? 'Show Source Data' : 'Hide Source Data' }}
        </Button>
        <Button @click="hideTarget = !hideTarget">
          {{ hideTarget ? 'Show Target Data' : 'Hide Target Data' }}
        </Button>
      </template>
    </PageTitle>
    <b-container fluid>
      <b-row>
        <b-col
          xs="12"
          :md="hideTarget ? 12 : 6"
          xl="4"
          order="0"
          :class="['mb-3', hideSource ? 'hidden' : '']"
        >
          <Card title="Source Data" class="fill-height" no-body>
            <template #header-suffix>
              <IconTooltip
                tooltip="The first record of your latest query"
                tooltip-position="left"
              />
            </template>
            <prism-editor
              v-model="previewSourceData"
              language="json"
              readonly
              class="input"
              :class="{ input: true, hidden: hideSource }"
            />
            <!-- @editorClick="handleSourceClick" -->
            <!-- emit&#45;events -->
          </Card>
        </b-col>
        <b-col
          xs="12"
          :xl="xlTransform"
          order="1"
          order-md="2"
          order-xl="1"
          class="mb-3"
        >
          <SimpleTransformForm />
        </b-col>
        <b-col
          xs="12"
          :md="hideSource ? 12 : 6"
          xl="4"
          order="2"
          order-md="1"
          order-xl="2"
          :class="['mb-3', hideTarget ? 'hidden' : '-height']"
        >
          <Card title="Transformed Data" class="fill-height" no-body>
            <template #header-suffix>
              <IconTooltip
                tooltip="The first record of your last record with the current transformation applied"
                tooltip-position="left"
              />
            </template>
            <prism-editor
              v-model="previewTransformedData"
              language="json"
              readonly
              :class="{ hidden: hideTarget }"
            />
          </Card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

import store from '@/plugins/vuex';

import Button from '@/components/Button.vue';
import Card from '@/components/Card.vue';
import IconTooltip from '@/components/IconTooltip.vue';
import PageTitle from '@/components/PageTitle.vue';
import SimpleTransformForm from '@/components/transformers/SimpleTransformForm.vue';

export default defineComponent({
  name: 'Transform',
  components: {
    Button,
    Card,
    IconTooltip,
    PageTitle,
    SimpleTransformForm,
  },
  data() {
    return {};
  },
  // created() { },
  computed: {
    ...mapGetters({
      previewSourceObject: 'transform/previewSourceObject',
    }),
    previewSourceData() {
      if (this.previewSourceObject) {
        return JSON.stringify(this.previewSourceObject, null, 2);
      }
      return 'Please connect to source and\nread source data to preview transform';
      // return undefined;
    },
    previewTransformedData() {
      const object = store.getters.transform.previewTransformedObject;
      if (object) {
        return JSON.stringify(object, object, 2);
      }
      return undefined;
    },
    hideSource: {
      get() {
        return store.state.ui.hideTransformSourcePreview;
      },
      set(value: boolean) {
        store.commit.ui.sethideTransformSourcePreview(value);
      },
    },
    hideTarget: {
      get() {
        return store.state.ui.hideTransformTargetPreview;
      },
      set(value: boolean) {
        store.commit.ui.sethideTransformTargetPreview(value);
      },
    },
    mdTransform() {
      let cols = 4;
      if (this.hideSource) {
        cols += 6;
      }
      if (this.hideTarget) {
        cols += 6;
      }
      return cols;
    },
    xlTransform() {
      let cols = 4;
      if (this.hideSource) {
        cols += 4;
      }
      if (this.hideTarget) {
        cols += 4;
      }
      return cols;
    },
  },
});
</script>
<style>
/*
.input .token.property:hover {
  cursor: pointer;
  background-color: rgba(100, 100, 100, 0.3);
}
*/
</style>
